import _ from 'underscore';
import $ from 'jquery';
import UpgradedUrl from '@bingads-webui-component-legacy/upgraded-url/view/index';
import AdExtensionEditor from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import { getLength } from '@bingads-webui-component-legacy/ko-validation/validators/string';
import config from '@bingads-webui-component-legacy/config/index';
import { testUurl, uurlLevels } from '@bingads-webui-component-legacy/upgraded-url/service/testUurl';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

export default class BaseSitelink extends AdExtensionEditor {
  initialize({
    extension,
    data,
    campaignId,
    adgroupId,
    schema,
    entityType,
    placeholderEnabled,
    destinationURLDisabled,
    isForVNext,
  } = {}) {
    const fields = [{
      property: 'DisplayText',
      placeholder: i18n.get('AdExtensions_Sitelink_Placeholder_Text'),
      showHint: true,
    }, {
      property: 'Description1',
      placeholder: i18n.get('AdExtensions_Sitelink_Placeholder_Description1'),
      ariaLabel: i18n.get('AdExtensions_Sitelink_Label_Description1'),
      showHint: true,
    }, {
      property: 'Description2',
      placeholder: i18n.get('AdExtensions_Sitelink_Placeholder_Description2'),
      ariaLabel: i18n.get('AdExtensions_Sitelink_Label_Description2'),
      showHint: true,
      showLabel: false,
    }, {
      property: 'DevicePreference',
      values: ['Mobile', 'All'],
      control: 'checkbox',
    }];

    this.campaignId = campaignId;
    this.adgroupId = adgroupId;

    const showUurlTestTool = !extension || !extension.customActions;

    if (_.isObject(extension)) {
      //resolve sitelink1 and sitelink2 schema inconsistency
      const mobileFinalUrls = extension.FinalMobileUrls;
      const isFinal = !(_.isEmpty(extension.FinalUrls) && _.isEmpty(mobileFinalUrls));
      const url = isFinal ? _.first(extension.FinalUrls) : extension.DestinationUrl;
      const isMobile = extension.DevicePreference === 'Mobile';

      this.upgradedUrlView = new UpgradedUrl({
        url,
        isFinal,
        finalMobileUrl: _.first(mobileFinalUrls),
        trackingTemplate: extension.TrackingUrlTemplate,
        finalUrlSuffix: extension.FinalUrlSuffix,
        customParameters: extension.UrlCustomParameters,
        urlOptionsEnabled: true,
        isMobilePreferred: isMobile,
        entityType,
        placeholderEnabled,
        useUrlOptionsV2: true,
        landingPageUrlRequired: true,
        destinationURLDisabled,
        showUurlTestTool,
        isForVNext,
      });
    } else {
      this.upgradedUrlView = new UpgradedUrl({
        urlOptionsEnabled: true,
        isMobilePreferred: false,
        entityType,
        placeholderEnabled,
        useUrlOptionsV2: true,
        landingPageUrlRequired: true,
        destinationURLDisabled,
        showUurlTestTool,
        isForVNext,
      });
    }

    super.initialize({
      extension,
      schema,
      data,
      fields,
      customValidators: {
        Description1: this._validator('Description2'),
        Description2: this._validator('Description1'),
        //Link text must be 25 characters or less if Description is added
        DisplayText: {
          isValid: (displayText) => {
            if (!this.viewModel) {
              return false;
            }
            // eslint-disable-next-line new-cap
            const description1 = this.viewModel.Description1();

            const {maxLengthWithDescription, maxLength, distinguishWideChar} = schema.properties.DisplayText;

            if (_.isUndefined(description1) || _.isEmpty(description1)) {
              this.viewModel.DisplayText.maxLength(maxLength);

              return true;
            }
            this.viewModel.DisplayText.maxLength(maxLengthWithDescription);

            return getLength(displayText, distinguishWideChar) <= maxLengthWithDescription;
          },
          message: () => {
            return i18n.get('Validation_AdExtensions_NewSiteLink_DisplayText', {count: schema.properties.DisplayText.maxLengthWithDescription});
          },
        },
      },
    });
    this.viewModel.Description1.subscribe(() => this.viewModel.Description2.validate());
    this.viewModel.Description2.subscribe(() => this.viewModel.Description1.validate());
  }

  render() {
    super.render();

    if (this.upgradedUrlView) {
      const $devicePreferenceElem = this.$('[data-property=DevicePreference] input:checkbox');

      $devicePreferenceElem.change(this.upgradedUrlView.devicePreferenceChanged.bind(this.upgradedUrlView));
      this.$('.extension-editor__extra').empty().append(this.upgradedUrlView.render().el);

      this.upgradedUrlView.on('testUurl', (fn, originalView) => {
        const upgradedUrlView = this.upgradedUrlView;

        if (!upgradedUrlView.isValid()) {
          fn.call(originalView, null); // to stop the loading spinner
          return;
        }

        originalView.isInline = false;
        originalView.level = uurlLevels.AdExtension;

        const customParameters = upgradedUrlView.urlOptions.getUrlCustomParameters();
        const UrlCustomParameters = [];

        _.each(customParameters, (o) => {
          const obj = {};
          const key = _.keys(o)[0];

          obj.Key = key;
          obj.Value = o[key];
          UrlCustomParameters.push(obj);
        });

        const params = {
          FinalUrls: upgradedUrlView.urlEditor.getFullUrl(),
          TrackingUrlTemplate: upgradedUrlView.urlOptions.trackingTemplate.getTrackingTemplate(),
          UrlCustomParameters,
          FinalUrlSuffix: upgradedUrlView.urlOptions.finalUrlSuffix.getFinalUrlSuffix(),
        };
        const context = {
          customerId: _.result(config.get('CurrentCustomer'), 'Id'),
          userId: _.result(config.get('CurrentUser'), 'Id'),
          accountId: _.result(config.get('CurrentAccount'), 'Id'),
          campaignId: this.campaignId,
          adGroupId: this.adgroupId,
          entityId: this.model && this.model.Id ? this.model.Id : '',
        };
        const options = {
          apiInLog: 'base-sitelink/uurlTest',
        };

        $('div.k-window-content.k-content').css({
          overflow: 'visible',
        });

        testUurl(fn, originalView, params, context, options);
      });
    }

    return this;
  }

  remove() {
    if (this.upgradedUrlView) {
      this.upgradedUrlView.remove();
    }

    super.remove();
  }

  currentModel() {
    const sitelink = super.currentModel();

    if (this.upgradedUrlView) {
      _.extend(sitelink, this.upgradedUrlView.toObject());
    }

    return sitelink;
  }

  _validator(otherName) {
    const message = () => {
      return i18n.get('Validation_AdExtensions_NewSiteLink_DescriptionRequired');
    };

    return {
      isValid: (thisOne) => {
        if (!this.viewModel || !this.viewModel[otherName]) {
          return false;
        }

        const otherObservable = this.viewModel[otherName];
        const otherOne = otherObservable();

        return _.isEmpty(thisOne) === _.isEmpty(otherOne);
      },
      message,
    };
  }
}
